import { render } from "./SeStdTaxForm1040s1.vue?vue&type=template&id=351c1f84"
import script from "./SeStdTaxForm1040s1.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1040s1.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1040s1.vue?vue&type=style&index=0&id=351c1f84&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__